module.exports = __webpack_public_path__ + "img/ekyc_doc_poa.96cdc9a4.svg";